import { gradingIdSchema } from "@repo/app-types/entities/teammatePerformanceSummary";
import { z } from "zod";
import { usePrefillFromUrl } from "../../../hooks/usePrefillFromUrl.js";

const knowledgeBaseFindingPrefillSchema = z.object({
  gradingId: gradingIdSchema,
  statementIndex: z.int().min(0),
});

/**
 * The knowledge base adherence finding a reviewer was looking at before
 * choosing to edit the article, carried to the document page in the `prefill`
 * query param and turned into the first message of an Ask Alpharun thread.
 */
export type KnowledgeBaseFindingPrefill = z.infer<
  typeof knowledgeBaseFindingPrefillSchema
>;

export function useKnowledgeBaseFindingPrefillFromUrl(): KnowledgeBaseFindingPrefill | null {
  return usePrefillFromUrl(knowledgeBaseFindingPrefillSchema);
}

/**
 * The message that opens the thread. It names the finding and leaves the
 * triage to the agent, which asks whether the document is wrong or the
 * expectation is before drafting anything.
 */
export function buildKnowledgeBaseFindingPrefillMessage(
  prefill: KnowledgeBaseFindingPrefill,
): string {
  return `I'm looking at a knowledge base adherence finding (grading id: ${prefill.gradingId}, statement index: ${prefill.statementIndex}) and the document it was judged against.

Can you help me work out what to change? It may be that the document is inaccurate or out of date, or that the finding itself is not relevant.`;
}
